import createSimpleObserver from '../simple-observer.js';
import enforceObservableRules from '../enforce-rules.js';
function createStorageAtomFactory({ storage, }) {
    return _createStorageAtomFactory({ storage });
}
const _createStorageAtomFactory = ({ storage }) => {
    function createStorageAtom({ key, defaultValue }) {
        let version = 0;
        const { notify, observe, listeners } = createSimpleObserver({ enable: true });
        let canUseCached = false;
        let cached;
        let pendingWrite;
        const set = async (value) => {
            version++;
            pendingWrite = (async () => {
                if (value === undefined) {
                    await storage.delete(key);
                    canUseCached = false;
                }
                else {
                    await storage.set(key, value);
                    canUseCached = true;
                }
                cached = value;
                pendingWrite = undefined;
            })();
            await pendingWrite;
            await notify(value);
            if (!canUseCached && listeners.length > 0) {
                listeners.forEach((listener) => listener.resetCallState());
            }
        };
        const get = async () => {
            if (pendingWrite) {
                await pendingWrite;
            }
            if (canUseCached) {
                return cached;
            }
            const currentVersion = version;
            const value = (await storage.get(key));
            if (currentVersion !== version) {
                return get();
            }
            cached = value;
            canUseCached = true;
            return value;
        };
        return enforceObservableRules({
            get,
            set,
            observe,
            defaultValue,
            makeGetNonConcurrent: true,
        });
    }
    return createStorageAtom;
};
export default createStorageAtomFactory;
